import { useSelector, shallowEqual } from 'react-redux';
import { getAutoRefillCountry } from '../selectors';

export const useAutoRefillCountry = () => ({
  autoRefillCountry: useSelector(getAutoRefillCountry, shallowEqual),
});
